import { useMemo } from 'react';

import { ProductType } from '@/generated/graphql';
import type {
  GetShoppingSummaryItineraryQuery,
  ItineraryProduct,
  TransportType,
} from '@/generated/graphql';
import summaryResolver from '@/components/FlightSummary/FlightSummary/resolver';
import type { CompletedSegment } from '@/components/FlightSummary/Segment/resolver';

interface MapItineraryData extends Omit<HotelDealsProps, 'amountNights'> {
  segments: CompletedSegment[];
  isMultiDestination: boolean;
  isRoundTrip: boolean;
  transportTypes: TransportType[];
}

interface HotelDealsProps {
  amountNights: number;
  destinationName: string;
}

const getFilteredItinerary = (data) =>
  data?.find(
    (product) => product.id?.type === ProductType.Itinerary
  ) as ItineraryProduct;

const useItineraryData = (
  data:
    | GetShoppingSummaryItineraryQuery['getShoppingSummary']['products']
    | undefined
): MapItineraryData => {
  const itinerary = useMemo(
    () => getFilteredItinerary(data) || data?.[0],
    [data]
  );
  const legs = itinerary?.productInfo?.legs || [];
  const { segments } = summaryResolver(legs);
  const isMultiDestination = legs.length > 2;
  const isRoundTrip = segments.length > 1;
  const destinationName = segments?.[0]?.destination?.cityName || '';
  const transportTypes = itinerary?.productInfo?.transportTypes || [];

  return {
    segments,
    isMultiDestination,
    isRoundTrip,
    destinationName,
    transportTypes,
  };
};

export default useItineraryData;
